// Sidebar.tsx
import React, { useState } from 'react';
import { Menu, Layout, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import './SidebarNavigation.css'; 
import DashboardIcon from '../../assets/order-icon.svg';
import UserDashboardIcon from '../../assets/user-icon.svg';
import ReportIcon from '../../assets/report_icon.svg';
import PO_icon from '../../assets/po-icon.svg';
import SubMenu from 'antd/es/menu/SubMenu';
import { getUserRole } from '../../utilities/CommonHelper';
import { getUserAccessData } from '../../utilities/sessionHelper';


const { Sider } = Layout;
const { Item } = Menu;

const getRole = () => {
  return (getUserRole(getUserAccessData()?.roleAccessMap) || '').toLowerCase();
};

const isAdminOrSuperuser = () => {
  const r = getRole();
  return r.includes('admin') || r.includes('superuser') || r.includes('super user');
};

const getReportsChildren = () => {
  const base = [
    {path:'/obo-report',label:'OBO Report'},
    {path:'/obo-report-old',label:'OBO Report Old'},
    {path:'/sow-ageing-report',label:'SOW Ageing Report'},
    {path:'/sow-revenue-report',label:'SOW Revenue Report'},
    {path:'/consolidated-revenue-forecasting',label:'Consolidated Revenue Forecasting'},
  ];
  if (isAdminOrSuperuser()) {
    base.push({path:'/bcp-report',label:'BCP Report'});
  }
  return base;
};

const tabs :{ path: string; label: string; icon?: React.ReactNode,children?:any }[]=[
    {path:'/orderDashboard',label:'Order Dashboard',icon:<img src={DashboardIcon} alt="dashboard-icon"/>},
    {path:'/userDashboard',label:'User Dashboard',icon:<img src={UserDashboardIcon} alt="userdashboard-icon"/>},
    {path:'/reports',label:'Reports',icon:<img src={ReportIcon} alt="obo-Report-icon"/>,
      children: getReportsChildren(),
  },
    
]

interface SidebarProps {
  locationPath: string;
}

const SidebarNavigation: React.FC<SidebarProps> = ({ locationPath }) => {
    const [collapsed, setCollapsed] = useState(true);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
  return (
    <>
    {(locationPath !=="/login") &&
    <Sider 
      theme="light"
      className={`sidebar ${collapsed ? 'collapsed' : ''}`}
      collapsible
      collapsed={collapsed}
      zeroWidthTriggerStyle={{top:'100px', right:'100px'}}
      onCollapse={toggleCollapsed}>
      <Menu style={{height:'94vh',minWidth:'40px'}} mode="inline" selectedKeys={[locationPath]} >
        {tabs.map((tab) =>

          tab.children?(
            <SubMenu style={{borderRadius:'0px'}} key={tab.path}title={tab.label} icon={tab.icon}>
              {tab.children.map((childTab:any)=>
                <Item key={childTab.path}title="">
                  <Tooltip title={childTab.label} placement="right">
                    <Link to={childTab.path} onClick={()=>setCollapsed(true)} style={{textDecoration:'none'}}  >
                      {childTab.icon}
                      <span style={{paddingLeft:'5px'}}>{childTab.label}</span>
                    </Link>
                  </Tooltip>
                </Item>
              )}
            </SubMenu>
          ):
          <Item style={{borderRadius:'0px'}} key={tab.path}title="">
            <Tooltip title={tab.label} placement="right">
              <Link to={tab.path} onClick={()=>setCollapsed(true)} style={{textDecoration:'none'}}  >
                {tab.icon}
                <span style={{paddingLeft:'5px'}}>{collapsed?"":tab.label}</span>
              </Link>
            </Tooltip>
          </Item>

          //   !tab.path.includes("/reports/")?(
          //   <Item style={{borderRadius:'0px'}} key={tab.path}title="">
          //     <Tooltip title={tab.label} placement="right">
          //   <Link to={tab.path} onClick={()=>setCollapsed(true)} style={{textDecoration:'none'}}  >
          //     {tab.icon}
          //     <span style={{paddingLeft:'5px'}}>{collapsed?"":tab.label}</span>
          //   </Link>
          //   </Tooltip>
          // </Item>)
          // :
          // ( <SubMenu style={{borderRadius:'0px'}} key={tab.path}title="Reports" icon={<img src={ReportIcon} alt="Report-icon"/>}>
          //   <Item key={tab.path}title="">
          //     <Tooltip title={tab.label} placement="right">
          //   <Link to={tab.path.split('/reports')[1]} onClick={()=> { setCollapsed(true)}} style={{textDecoration:'none'}}  >
          //     {tab.icon}
          //     <span style={{paddingLeft:'5px'}}>{tab.label}</span>
          //   </Link>
          //   </Tooltip>
          // </Item>
          //   </SubMenu>
          // )
        )}
      </Menu>
    </Sider>}
    </>
  );
};

export default SidebarNavigation;
